export default (controller) => {
  Object.assign(controller, {
    reorderForms(forms, closeEvent = null) {
      this.order = null;
      this.updateOrder(forms, closeEvent);
      this.handleDestroyButton();
      if (this.hasOrderTarget) {
        this.orderTarget.innerHTML = this.order;
      }
    },

    updateOrder(forms, closeEvent = null) {
      for (let i = 0, counter = 0; i < forms.length; i += 1) {
        if (closeEvent && closeEvent.detail === forms[i]) continue;

        counter += 1;
        if (this.element.contains(forms[i])) {
          this.order = counter;
          break;
        }
      }
    },

    handleDestroyButton() {
      if (this.hasDestroyButtonTarget) {
        this.destroyButtonTarget.disabled = this.order === 1;
      }
    },

    destroy() {
      this.fieldsTarget.remove();
      this.dispatch('close', { detail: this.element });
    },
  });
};
